import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useLocation} from 'react-router-dom';
import authenticationService from '../../../services/authentication/AuthenticationService';
import OverlayMessage from '../../overlayMessage';
import LinkButtonView from '../../buttons/link';
import {useClientsStore} from '../ClientsStore';
import {USER_REQUEST_TYPES} from '../../../utils/constant';

function MessageView({plan}) {
  const {state: {depositor}} = useClientsStore();
  const isExplorer = authenticationService.roles().isExplorer();
  const location = useLocation();

  // Overlays depending on depositor status
  if (isExplorer && depositor.isActive) {
    return (
      <OverlayMessage
        type="role"
        message={<Translate value="message.roleNotAllowed"/>}
      >
        <LinkButtonView
          link={`${location.pathname}?contact=${USER_REQUEST_TYPES.MY_ROLE}`}
          buttonLabel={<Translate value="contact.title"/>}
        />
      </OverlayMessage>
    );
  }

  if (!depositor.isActive) {
    // Collector only with upgradable plan can upgrade their offer in autonomy
    if (!plan.depositorServiceAuthorized && plan.upgradable) {
      return (
        <OverlayMessage
          type="document"
          message={<Translate value="document.planUpgradable"/>}
        >
          <LinkButtonView
            link={'/register-organisation-plan'}
            buttonLabel={<Translate value="plan.actions.upgrade"/>}
          />
        </OverlayMessage>
      );
    }

    // Otherwise client has to contact the customer service
    return (
      <OverlayMessage
        type="document"
        message={<Translate value="document.notDepositor"/>}
      >
        <LinkButtonView
          link={`${location.pathname}?contact=${USER_REQUEST_TYPES.MY_OFFER}`}
          buttonLabel={<Translate value="plan.actions.contactUs"/>}
        />
      </OverlayMessage>
    );
  }

  return null;
}

MessageView.propTypes = {
  plan: PropTypes.shape({
    loading: PropTypes.bool,
    depositorServiceAuthorized: PropTypes.bool,
    upgradable: PropTypes.bool
  }).isRequired
};

export default MessageView;
